export default "__VITE_ASSET__DDfEkYyV__"